<template>
  <div
    :class="['boss-table-2-layout', { 'boss-table-2-layout-half': half }]"
    data-test="layout"
  >
    <div
      class="boss-table-2-item boss-table-2-item-head"
      data-test="label"
    >
      <slot name="before-label" />
      {{ label }}
      <span
        v-if="isRequired"
        class="label alert"
      >必須</span>
      <div
        v-if="explanation"
        class="boss-annotation-text"
        data-test="explanation"
      >
        {{ explanation }}
      </div>
    </div>
    <div
      class="width-100"
      :class="['boss-table-2-item', 'boss-table-2-item-body', { 'boss-table-2-item-body-has-child': hasChild }, { 'is-modified': isModified }]"
      data-test="body"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    half: {
      default: false,
      type: Boolean
    },
    hasChild: {
      default: false,
      type: Boolean
    },
    isModified: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    },
    isRequired: {
      default: false,
      type: Boolean
    },
    explanation: {
      default: '',
      type: String
    }
  }
}
</script>
